import { useReducer } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFetch from "../../../hook/useFetch"
import { notificationActions } from "../../../store/notification-slice"
import { userActions } from "../../../store/user-slice"
import { useNavigate } from "react-router-dom"
import  parse  from 'html-react-parser';

export default function UserProfile() {
    let user = useSelector(state => state.user.user)


    const reducer = (state, action) => {
        switch (action.type) {
            case 'TOGGLE_MODAL':
                return { ...state, mountModal: !state.mountModal }
            case 'MODAL_DATA':
                return { ...state, modalData: action.data }
            case 'password':
                return { ...state, password: action.data }
            case 'confirmation_password':
                return { ...state, confirmation_password: action.data }
            case 'username':
                return { ...state, username: action.data }


        }
    }


    const [componentState, componentDispatch] = useReducer(reducer, {
        mountModal: false,
        modalData: null,

        password: null,
        confirmation_password: null,
        username: null,
        email: null

    })


    let dispatch = useDispatch()

    const { error, update } = useFetch()


    let navigate = useNavigate()

    return <div className="edit-container grid-container-2-col" >

        <form className="edit-form bg-white left-col" onSubmit={(e) => {
            e.preventDefault()

            update(`/user/update-data`, {
                username: componentState.username,
                password: componentState.password,
                confirmation_password: componentState.confirmation_password,
                email: componentState.email,

            }, null, () => {
                dispatch(notificationActions.setNotification({
                    message: `user updated`,
                    status: true
                }))

                dispatch(userActions.updateUser([
                    {
                        key: 'username',
                        value: componentState.username?componentState.username:user.username
                    }
                ]))

                if (componentState.password) {
                    dispatch(userActions.setUser(null))
                   
                    navigate('/')
                }

            })
        }} >

            {error &&
                <div className="alert bg-danger " >
                    <p>{parse(error)}</p>
                </div>
            }

            <div className="form-group">
                <label htmlFor="username">Username</label>
                <input id="username" type="text" className="form-control" placeholder="Username" defaultValue={user.username} onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'username',
                            data: e.target.value
                        }
                    )
                }} required />

            </div>
            <div className="form-group">
                <label htmlFor="email">Email address</label>
                <input id="email" type="email" className="form-control" placeholder="Email" defaultValue={user.email} disabled onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'email',
                            data: e.target.value
                        }
                    )
                }} required />

            </div>
            <div className="form-group">
                <label htmlFor="password">Password</label>
                <input id="password" type="password" className="form-control" placeholder="Password" onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'password',
                            data: e.target.value
                        }
                    )
                }} />
            </div>

            <div className="form-group">
                <label htmlFor="password-confirm">Password Confirmation</label>
                <input id="password-confirm" type="password" className="form-control" placeholder="Password Confirmation" onInput={(e) => {
                    componentDispatch(
                        {
                            type: 'confirmation_password',
                            data: e.target.value
                        }
                    )
                }} />
            </div>



            <button type="submit" className="btn btn-primary" >Update</button>

        </form>


    </div>
}